import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FocusService } from './focus.service';

@NgModule({
  imports: [CommonModule],
  providers: [FocusService],
})
export class FocusModule {}
